document.addEventListener('DOMContentLoaded', function() {
    function updateModalMargin() {
        var header = document.querySelector('.header-wrapper');
        var modal = document.querySelector('.modal');

        if (header && modal) {
            var headerHeight = header.offsetHeight;
            modal.style.marginTop = headerHeight + 'px';
        }
    }

    updateModalMargin();

    window.addEventListener('resize', updateModalMargin);

    var modalOpenButtons = document.querySelectorAll('.modal_open_button');
    modalOpenButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            var slideshowButtons = document.querySelectorAll('.slider-buttons');
            slideshowButtons.forEach(function(element) {
                element.style.display = 'none';
            });

            var modal = button.parentElement.querySelector('.modal');
            var closeModalButton = modal.querySelector('.close');

            modal.style.display = 'block';

            document.body.classList.add('modal-open');

            function closeModal() {
                modal.style.display = 'none';
                document.body.classList.remove('modal-open');
            }

            closeModalButton.onclick = closeModal;

            window.onclick = function(event) {
                if (event.target == modal) {
                    closeModal();
                }
            };
        });
    });
});
